import { Drink } from "src/lib/db";
import Image, { transformImgSrc } from "./Image";

export function getDrinkImageUrl(drink: Drink) {
  if (!drink.icon)
    return `${process.env.REACT_APP_API_URL}/images/drink/vodka.svg`;

  if (drink.ownDrink) return transformImgSrc(drink.icon);

  return `${process.env.REACT_APP_API_URL}/images/drink/${drink.icon}`;
}

export default function DrinkImage({
  drink,
  ...props
}: { drink: Drink } & React.ImgHTMLAttributes<HTMLImageElement>) {
  if (!drink.icon)
    return (
      // eslint-disable-next-line jsx-a11y/alt-text
      <img
        src={`${process.env.REACT_APP_API_URL}/images/drink/vodka.svg`}
        {...props}
      />
    );

  if (drink.ownDrink) {
    return <Image src={drink.icon} {...props} />;
  }

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      src={`${process.env.REACT_APP_API_URL}/images/drink/${drink.icon}`}
      {...props}
    />
  );
}
